import type { UploadDocumentsResult } from './apiSchema';
import type { UploadDocumentsResponse } from './schema';

export function normalizeUploadDocuments(
  data: UploadDocumentsResult,
): UploadDocumentsResponse {
  return {
    file_id: data.file_id,
    type: data.type,
    url: data.url,
  };
}
